import React from 'react';
import '../styles/HowItWorks.css';

import img404 from '../assets/404.webp';

const NotFound: React.FC = () => {
  return (
    <div className="how-it-works-container">
      <img src={img404} alt="404" className="img404" />

      <div className="buttons-container">
        <p>
          This page or token could not be found.
        </p>
      </div>
    </div>
  );
};

export default NotFound;